var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBKashLogoIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_1486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8468 31.2775L27.3636 28.2244L29.9465 39.8342L46.8468 31.2775Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8468 31.2774L32.1655 10.8794L27.3673 28.228L46.8468 31.2774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9118 27.9928L11.5288 8.33325L31.6733 10.7397L26.9118 27.9928Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9054 19.7777L11.3634 11.728H13.6119L19.9054 19.7777Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0021 21.3613L47.3869 31.1672L41.5269 23.0624L51.0021 21.3613Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2207 39.2462L46.406 33.5478L47.0012 31.7366L32.2207 39.2462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8752 50.0001L26.952 28.6836L30.0345 42.5529L20.8752 50.0001Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5679 21.4385L50.0763 25.4872L55.455 25.399L51.5679 21.4385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_1486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 50,
    fill: "white",
    transform: "translate(-8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBKashLogoIcon1);
export default __webpack_public_path__ + "static/media/BKash_Logo_icon 1.270d84a0ca84d56d32c64511dfd1195a.svg";
export { ForwardRef as ReactComponent };